import moment from "moment";
import { txt } from "./translation";

export function timeAgo(date){

    const start = moment(date);

    const d = moment().diff(start, 'days');
    const h = moment().diff(start, 'hour');
    const m = moment().diff(start, 'minute');
    const M = moment().diff(start, 'month');
    const y = moment().diff(start, 'year');

    if(y > 1) return txt('yearsAgo', {n: y});

    if(M > 1) return txt('monthsAgo', {n: M});

    if(M === 1) return txt('oneMonthAgo', {n: M});

    if(d > 1) return txt('daysAgo', {n: d});

    if(d === 1) return txt('yesterday');

    if(h > 1) return txt('hoursAgo', {n: h});

    if(h === 1) return txt('oneHourAgo');

    if(m > 2) return txt('minutesAgo', {n: m});

    if(m <= 2) return txt('now');

    return txt('today');
    
}